module.exports = __webpack_public_path__ + "img/icon-cctv.6280443d.png";